/* mp-cookie-link.js (Minimalerei, Nov 2026)
   Blendet das schwebende Pandectes-Icon (button.widget im Shadow-DOM von <pandectes-cmp>) aus
   und öffnet die Cookie-Einstellungen stattdessen über Links:
   a[href$="#cookie-einstellungen"], a[href$="#cookies"], [data-cookie-settings].
   Das Consent-Banner selbst bleibt unberührt (CSS greift nur auf button.widget).
   Setzt zusätzlich „Cookie-Einstellungen“ in die Rechtstexte-Zeile im Footer. */
(function () {
  'use strict';
  if (window.__mpCookieLink) return;
  window.__mpCookieLink = true;

  var STYLE_ID = 'mp-cookie-link-hide';
  var LINKS = 'a[href$="#cookie-einstellungen"], a[href$="#cookies"], [data-cookie-settings]';
  var HASHES = ['#cookie-einstellungen', '#cookies'];
  var observed = [];

  function host() { return document.querySelector('pandectes-cmp'); }
  function root() { var h = host(); return h && h.shadowRoot ? h.shadowRoot : null; }
  function widget() { var r = root(); return r ? r.querySelector('button.widget') : null; }

  function ensureStyle(r) {
    try {
      if (!r || r.getElementById(STYLE_ID)) return;
      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = 'button.widget{display:none!important}';
      r.appendChild(st);
    } catch (e) { /* nichts tun */ }
  }

  function attach(r) {
    ensureStyle(r);
    if (observed.indexOf(r) !== -1 || !window.MutationObserver) return;
    observed.push(r);
    // Rendert Pandectes neu und entfernt dabei unseren Style, wieder einsetzen.
    new MutationObserver(function () { ensureStyle(r); }).observe(r, { childList: true });
  }

  function openFromHash() {
    if (HASHES.indexOf(window.location.hash) === -1) return;
    var b = widget();
    if (b) { try { b.click(); } catch (e) { /* nichts tun */ } }
  }

  function tryAttach() {
    var r = root();
    if (!r) return false;
    attach(r);
    return true;
  }

  function start() {
    var started = Date.now();
    var hashDone = false;
    (function poll() {
      if (tryAttach()) {
        if (!hashDone && widget()) { hashDone = true; openFromHash(); }
        if (hashDone || Date.now() - started > 20000) return;
      } else if (Date.now() - started > 20000) {
        return; // Pandectes nicht gefunden: aufgeben, keine Fehler.
      }
      setTimeout(poll, 300);
    })();

    // Falls Pandectes das Element später ersetzt: neues Element erneut versehen.
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var added = list[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.nodeName === 'PANDECTES-CMP' || (n.querySelector && n.querySelector('pandectes-cmp')))) {
              setTimeout(tryAttach, 0);
              return;
            }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  /* Footer: Link „Cookie-Einstellungen“ automatisch hinter „Datenschutzerklärung“ einfügen,
     falls im Footer noch keiner steht (kein Menü nötig). */
  function addFooterLink() {
    var priv = document.querySelector('[id*="__footer"] a[href*="/policies/privacy-policy"]') || document.querySelector('footer a[href*="/policies/privacy-policy"]');
    var li = priv && priv.closest('li');
    if (!li || !li.parentElement || li.parentElement.querySelector(LINKS)) return;
    var nli = li.cloneNode(false);
    var a = document.createElement('a');
    a.href = '#cookie-einstellungen';
    a.className = priv.className;
    a.textContent = 'Cookie-Einstellungen';
    nli.appendChild(a);
    li.insertAdjacentElement('afterend', nli);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest(LINKS);
    if (!link) return;
    e.preventDefault();
    var b = widget();
    if (!b) return;
    try { b.click(); } catch (err) { /* nichts tun */ }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { addFooterLink(); start(); });
  else { addFooterLink(); start(); }
})();
